export enum GlobalPickerManagementOption {
  RegisterRecipe = 1,  
  RegisteredRecipes = 2,
  ConfirmSeparation = 3
}